module.exports = {"320305001":"老矿街道","320305003":"大泉街道","320305004":"大吴街道","320305005":"潘安湖街道","320305006":"茱萸山街道","320305102":"青山泉镇","320305104":"紫庄镇","320305105":"塔山镇","320305106":"汴塘镇","320305107":"江庄镇","320305401":"鹿庄粮棉原种场","320305402":"工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320305.json
// module id = 850
// module chunks = 0